import archiver from 'archiver';
import { createWriteStream } from 'fs';
import { exec } from 'child_process';
import { promisify } from 'util';
import { PackageManager, PackageOptions, PackageResult } from '../types';
import { PackageManagerResolver } from '../utils';

const execAsync = promisify(exec);

export class Packager {
	private static readonly COMPRESSION_LEVEL = 9;
	private static readonly CONCURRENCY = 10;

	async package(options: PackageOptions): Promise<PackageResult> {
		const command = PackageManagerResolver.getListCommand(
			options.packageManager,
			options.productionOnly,
		);

		const { stdout } = await execAsync(command);
		const dependencies = this.parseDependencies(stdout, options.packageManager);

		const fileName = `${options.name}.zip`;
		await this.createArchive(fileName, dependencies, options.directory);

		return {
			fileName,
			size: 0, // TODO: Add file size calculation
			dependencies,
		};
	}

	private parseDependencies(output: string, manager: PackageManager): string[] {
		const parsed = JSON.parse(output);
		const deps =
			manager === PackageManager.PNPM
				? parsed[0].dependencies
				: parsed.dependencies;

		return [...Object.keys(deps), '@types'];
	}

	private createArchive(
		fileName: string,
		deps: string[],
		directory: string,
	): Promise<void> {
		return new Promise((resolve, reject) => {
			const output = createWriteStream(fileName);
			const archive = archiver('zip', {
				zlib: { level: Packager.COMPRESSION_LEVEL },
				statConcurrency: Packager.CONCURRENCY,
			});

			output.on('close', resolve);
			output.on('error', reject);
			archive.pipe(output);

			deps.forEach((dep) => {
				archive.directory(`node_modules/${dep}`, `${directory}/${dep}`);
			});

			archive.finalize();
		});
	}
}
